/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SubmitRouteImport } from './routes/submit'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SupportIndexRouteImport } from './routes/support/index'
import { Route as SendIndexRouteImport } from './routes/send/index'
import { Route as PackIndexRouteImport } from './routes/pack/index'
import { Route as DeckIndexRouteImport } from './routes/deck/index'
import { Route as BookmarkIndexRouteImport } from './routes/bookmark/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as SupportSubmitRouteImport } from './routes/support/submit'
import { Route as ShareCodeRouteImport } from './routes/share/$code'
import { Route as PackPack_idRouteImport } from './routes/pack/$pack_id'
import { Route as DeckListRouteImport } from './routes/deck/list'
import { Route as DeckDeck_idRouteImport } from './routes/deck/$deck_id'
import { Route as OauthSiteCallbackRouteImport } from './routes/oauth/$site/callback'
import { Route as AdminPackPack_idRouteImport } from './routes/admin/pack/$pack_id'

const SubmitRoute = SubmitRouteImport.update({
  id: '/submit',
  path: '/submit',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportIndexRoute = SupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => rootRouteImport,
} as any)
const SendIndexRoute = SendIndexRouteImport.update({
  id: '/send/',
  path: '/send/',
  getParentRoute: () => rootRouteImport,
} as any)
const PackIndexRoute = PackIndexRouteImport.update({
  id: '/pack/',
  path: '/pack/',
  getParentRoute: () => rootRouteImport,
} as any)
const DeckIndexRoute = DeckIndexRouteImport.update({
  id: '/deck/',
  path: '/deck/',
  getParentRoute: () => rootRouteImport,
} as any)
const BookmarkIndexRoute = BookmarkIndexRouteImport.update({
  id: '/bookmark/',
  path: '/bookmark/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportSubmitRoute = SupportSubmitRouteImport.update({
  id: '/support/submit',
  path: '/support/submit',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareCodeRoute = ShareCodeRouteImport.update({
  id: '/share/$code',
  path: '/share/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const PackPack_idRoute = PackPack_idRouteImport.update({
  id: '/pack/$pack_id',
  path: '/pack/$pack_id',
  getParentRoute: () => rootRouteImport,
} as any)
const DeckListRoute = DeckListRouteImport.update({
  id: '/deck/list',
  path: '/deck/list',
  getParentRoute: () => rootRouteImport,
} as any)
const DeckDeck_idRoute = DeckDeck_idRouteImport.update({
  id: '/deck/$deck_id',
  path: '/deck/$deck_id',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthSiteCallbackRoute = OauthSiteCallbackRouteImport.update({
  id: '/oauth/$site/callback',
  path: '/oauth/$site/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPackPack_idRoute = AdminPackPack_idRouteImport.update({
  id: '/admin/pack/$pack_id',
  path: '/admin/pack/$pack_id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/submit': typeof SubmitRoute
  '/deck/$deck_id': typeof DeckDeck_idRoute
  '/deck/list': typeof DeckListRoute
  '/pack/$pack_id': typeof PackPack_idRoute
  '/share/$code': typeof ShareCodeRoute
  '/support/submit': typeof SupportSubmitRoute
  '/admin': typeof AdminIndexRoute
  '/bookmark': typeof BookmarkIndexRoute
  '/deck': typeof DeckIndexRoute
  '/pack': typeof PackIndexRoute
  '/send': typeof SendIndexRoute
  '/support': typeof SupportIndexRoute
  '/admin/pack/$pack_id': typeof AdminPackPack_idRoute
  '/oauth/$site/callback': typeof OauthSiteCallbackRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/submit': typeof SubmitRoute
  '/deck/$deck_id': typeof DeckDeck_idRoute
  '/deck/list': typeof DeckListRoute
  '/pack/$pack_id': typeof PackPack_idRoute
  '/share/$code': typeof ShareCodeRoute
  '/support/submit': typeof SupportSubmitRoute
  '/admin': typeof AdminIndexRoute
  '/bookmark': typeof BookmarkIndexRoute
  '/deck': typeof DeckIndexRoute
  '/pack': typeof PackIndexRoute
  '/send': typeof SendIndexRoute
  '/support': typeof SupportIndexRoute
  '/admin/pack/$pack_id': typeof AdminPackPack_idRoute
  '/oauth/$site/callback': typeof OauthSiteCallbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/submit': typeof SubmitRoute
  '/deck/$deck_id': typeof DeckDeck_idRoute
  '/deck/list': typeof DeckListRoute
  '/pack/$pack_id': typeof PackPack_idRoute
  '/share/$code': typeof ShareCodeRoute
  '/support/submit': typeof SupportSubmitRoute
  '/admin/': typeof AdminIndexRoute
  '/bookmark/': typeof BookmarkIndexRoute
  '/deck/': typeof DeckIndexRoute
  '/pack/': typeof PackIndexRoute
  '/send/': typeof SendIndexRoute
  '/support/': typeof SupportIndexRoute
  '/admin/pack/$pack_id': typeof AdminPackPack_idRoute
  '/oauth/$site/callback': typeof OauthSiteCallbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/submit'
    | '/deck/$deck_id'
    | '/deck/list'
    | '/pack/$pack_id'
    | '/share/$code'
    | '/support/submit'
    | '/admin'
    | '/bookmark'
    | '/deck'
    | '/pack'
    | '/send'
    | '/support'
    | '/admin/pack/$pack_id'
    | '/oauth/$site/callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/submit'
    | '/deck/$deck_id'
    | '/deck/list'
    | '/pack/$pack_id'
    | '/share/$code'
    | '/support/submit'
    | '/admin'
    | '/bookmark'
    | '/deck'
    | '/pack'
    | '/send'
    | '/support'
    | '/admin/pack/$pack_id'
    | '/oauth/$site/callback'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/submit'
    | '/deck/$deck_id'
    | '/deck/list'
    | '/pack/$pack_id'
    | '/share/$code'
    | '/support/submit'
    | '/admin/'
    | '/bookmark/'
    | '/deck/'
    | '/pack/'
    | '/send/'
    | '/support/'
    | '/admin/pack/$pack_id'
    | '/oauth/$site/callback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  SubmitRoute: typeof SubmitRoute
  DeckDeck_idRoute: typeof DeckDeck_idRoute
  DeckListRoute: typeof DeckListRoute
  PackPack_idRoute: typeof PackPack_idRoute
  ShareCodeRoute: typeof ShareCodeRoute
  SupportSubmitRoute: typeof SupportSubmitRoute
  AdminIndexRoute: typeof AdminIndexRoute
  BookmarkIndexRoute: typeof BookmarkIndexRoute
  DeckIndexRoute: typeof DeckIndexRoute
  PackIndexRoute: typeof PackIndexRoute
  SendIndexRoute: typeof SendIndexRoute
  SupportIndexRoute: typeof SupportIndexRoute
  AdminPackPack_idRoute: typeof AdminPackPack_idRoute
  OauthSiteCallbackRoute: typeof OauthSiteCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/submit': {
      id: '/submit'
      path: '/submit'
      fullPath: '/submit'
      preLoaderRoute: typeof SubmitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/': {
      id: '/support/'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/send/': {
      id: '/send/'
      path: '/send'
      fullPath: '/send'
      preLoaderRoute: typeof SendIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pack/': {
      id: '/pack/'
      path: '/pack'
      fullPath: '/pack'
      preLoaderRoute: typeof PackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deck/': {
      id: '/deck/'
      path: '/deck'
      fullPath: '/deck'
      preLoaderRoute: typeof DeckIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookmark/': {
      id: '/bookmark/'
      path: '/bookmark'
      fullPath: '/bookmark'
      preLoaderRoute: typeof BookmarkIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/submit': {
      id: '/support/submit'
      path: '/support/submit'
      fullPath: '/support/submit'
      preLoaderRoute: typeof SupportSubmitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/$code': {
      id: '/share/$code'
      path: '/share/$code'
      fullPath: '/share/$code'
      preLoaderRoute: typeof ShareCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pack/$pack_id': {
      id: '/pack/$pack_id'
      path: '/pack/$pack_id'
      fullPath: '/pack/$pack_id'
      preLoaderRoute: typeof PackPack_idRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deck/list': {
      id: '/deck/list'
      path: '/deck/list'
      fullPath: '/deck/list'
      preLoaderRoute: typeof DeckListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deck/$deck_id': {
      id: '/deck/$deck_id'
      path: '/deck/$deck_id'
      fullPath: '/deck/$deck_id'
      preLoaderRoute: typeof DeckDeck_idRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/$site/callback': {
      id: '/oauth/$site/callback'
      path: '/oauth/$site/callback'
      fullPath: '/oauth/$site/callback'
      preLoaderRoute: typeof OauthSiteCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/pack/$pack_id': {
      id: '/admin/pack/$pack_id'
      path: '/admin/pack/$pack_id'
      fullPath: '/admin/pack/$pack_id'
      preLoaderRoute: typeof AdminPackPack_idRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  SubmitRoute: SubmitRoute,
  DeckDeck_idRoute: DeckDeck_idRoute,
  DeckListRoute: DeckListRoute,
  PackPack_idRoute: PackPack_idRoute,
  ShareCodeRoute: ShareCodeRoute,
  SupportSubmitRoute: SupportSubmitRoute,
  AdminIndexRoute: AdminIndexRoute,
  BookmarkIndexRoute: BookmarkIndexRoute,
  DeckIndexRoute: DeckIndexRoute,
  PackIndexRoute: PackIndexRoute,
  SendIndexRoute: SendIndexRoute,
  SupportIndexRoute: SupportIndexRoute,
  AdminPackPack_idRoute: AdminPackPack_idRoute,
  OauthSiteCallbackRoute: OauthSiteCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
